export const inboxAppUrl = {
	cpURL: process.env.REACT_APP_URL,
	trackableLinkURL: process.env.REACT_APP_TRACKABLE_LINK_URL
}

export const accountAppUrl = {
	cpURL: process.env.REACT_APP_ACCOUNT_CP_URL
}
